@if (auth.isLoading$ | async) {
  <div
    class="flex max-h-full justify-center items-center"
    >
    <app-loading></app-loading>
  </div>
} @else {
  <app-change-email-flow-content
    [user]="profile"
  ></app-change-email-flow-content>
}

